module.exports = __webpack_public_path__ + "static/media/n8n.b7c59ee3.svg";